import { processGeojson } from 'kepler.gl/processors';
import { wrapTo, removeDataset } from 'kepler.gl/actions';
import { addDataToMap } from "kepler.gl/actions";

const SEGMENT_SCORE_GEO_JSON_PATH = "/final_segments_with_scores.geojson";

export const fetchAndProcessSegmentScoreGeoJSON = async (setLayerDataState, dispatch, store) => {
    let geojson;
    try {
        const response = await fetch(SEGMENT_SCORE_GEO_JSON_PATH);
        if (!response.ok) {
            console.error('Invalid Segment Score GeoJSON data', response.statusText);
        }

        // Parse the JSON data
        geojson = await response.json();
        if (!geojson || !geojson.features) {
            console.error('Invalid Segment Score GeoJSON data');
        }

        console.log("Segment Score GeoJSON", geojson);
    } catch(error) {
        console.error('Error fetching zone GeoJSON data:', error);
    }

    setLayerDataState((prev) => ({ ...prev, segmentScoreGeoJSON: geojson }));

    console.log("Sujeet Segment Score ProcessedGeoJson : ", processGeojson(geojson));

    dispatch(wrapTo('evidence', removeDataset('segmentscore')));

    dispatch(
        addDataToMap({
            datasets: [
                {
                    info: { label: "SegmentScore", id: "segmentscore" },
                    data: processGeojson(geojson)
                }
            ],
            options: {
                centerMap: false,
                readOnly: false,
                keepExistingConfig: true
            },
            config: {
                visState: {
                    interactionConfig: {
                        geocoder: {
                            enabled: true
                        }
                    },
                    layers: [
                        {
                            "id": "segmentscore",
                            "type": "geojson",
                            "config": {
                                "dataId": "segmentscore",
                                "columnMode": "geojson",
                                "label": "BLR Road Segment Score",
                                "color": [
                                    179,
                                    173,
                                    158
                                ],
                                "highlightColor": [
                                    252,
                                    242,
                                    26,
                                    255
                                ],
                                "columns": {
                                    "geojson": "_geojson",
                                    "Tree Score": "Tree Score",
                                    "Cleanliness Score": "Cleanliness Score",
                                    "Infra Score": "Infra Score",
                                    "Nuisance Score": "Nuisance Score"
                                },
                                "isVisible": false,
                                "visConfig": {
                                    "opacity": 0.8,
                                    "strokeOpacity": 0.8,
                                    "thickness": 0.5,
                                    "strokeColor": null,
                                    "colorRange": {
                                        "name": "Global Warming",
                                        "type": "sequential",
                                        "category": "Uber",
                                        "colors": [
                                        "#4C0035",
                                        "#880030",
                                        "#B72F15",
                                        "#D6610A",
                                        "#EF9100",
                                        "#FFC300"
                                        ]
                                    },
                                    "strokeColorRange": {
                                        "colors": [
                                            "#A50026",
                                            "#D8382D",
                                            "#F47C4A",
                                            "#FDBE70",
                                            "#FEEDA1",
                                            "#E9F5A1",
                                            "#B6E076",
                                            "#73C364",
                                            "#289B51",
                                            "#006837"
                                        ],
                                        "name": "RdYlGn",
                                        "type": "diverging",
                                        "category": "ColorBrewer"
                                    },
                                    "radius": 10,
                                    "sizeRange": [
                                        0,
                                        10
                                    ],
                                    "radiusRange": [
                                        0,
                                        50
                                    ],
                                    "heightRange": [
                                        0,
                                        500
                                    ],
                                    "elevationScale": 5,
                                    "stroked": true,
                                    "filled": false,
                                    "enable3d": false,
                                    "wireframe": false,
                                    "fixedHeight": false
                                },
                                "hidden": false,
                                "textLabel": [
                                    {
                                        "field": null,
                                        "color": [
                                        255,
                                        255,
                                        255
                                        ],
                                        "size": 18,
                                        "offset": [
                                        0,
                                        0
                                        ],
                                        "anchor": "start",
                                        "alignment": "center",
                                        "outlineWidth": 0,
                                        "outlineColor": [
                                        255,
                                        0,
                                        0,
                                        255
                                        ],
                                        "background": false,
                                        "backgroundColor": [
                                        0,
                                        0,
                                        200,
                                        255
                                        ]
                                    }
                                ]
                            },
                            "visualChannels": {
                                "colorField": null,
                                "colorScale": "quantile",
                                "strokeColorField": null,
                                "strokeColorScale": "quantile",
                                "sizeField": null,
                                "sizeScale": "linear",
                                "heightField": null,
                                "heightScale": "linear",
                                "radiusField": null,
                                "radiusScale": "linear"
                            }
                        }
                    ]
                }
            }
        })
    );

    console.log("Current Map Segment Score Configuration:", store.getState());

    console.log("Sujeet Segment Score useEffect end", geojson);
};